export default __webpack_public_path__ + "static/media/mike.fe979cd1.jpg";